const c = {
  name: "Lithuania",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,13c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S10.6,13,10,13z"/>
		<path class="st0" d="M15,12c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S15,11.4,15,12z"/>
		<path class="st0" d="M6,0v1.1C6,3.3,7.8,5,10,5H14c2.2,0,4-1.7,4-3.9V0h2v1.1c0,2.1-1.2,4-2.9,5c0.5,0.4,1,1,1.3,1.6
			C19,7.3,19.7,7,20.5,7c1.7,0,3,1.2,3.5,2.7L24,10L24,10.3c-0.5,1.5-1.8,2.7-3.5,2.7c-0.5,0-1-0.1-1.5-0.3V16c0,3.9-3.1,7-7,7
			c-3.9,0-7-3.1-7-7v-3.4C4.5,12.9,4,13,3.5,13c-1.7,0-3-1.2-3.5-2.7L0,10L0,9.7C0.5,8.2,1.8,7,3.5,7C4.3,7,5,7.3,5.6,7.7
			c0.3-0.6,0.8-1.2,1.3-1.6C5.2,5.1,4,3.3,4,1.1l0,0L4,0H6z M10,7c-1.7,0-3,1.3-3,3v5h10v-5c0-1.7-1.3-3-3-3H10z M7.1,17
			c0.5,2.3,2.5,4,4.9,4c2.4,0,4.4-1.7,4.9-4H7.1z M2.1,10c0.3,0.6,0.9,1,1.4,1c0.6,0,1.1-0.4,1.4-1C4.6,9.4,4.1,9,3.5,9
			C2.9,9,2.4,9.4,2.1,10z M20.5,11c0.6,0,1.1-0.4,1.4-1c-0.3-0.6-0.9-1-1.4-1c-0.6,0-1.1,0.4-1.4,1C19.4,10.6,19.9,11,20.5,11z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Lithuania
};
